import type { ComponentType } from 'react'
import { GoogleIcon, LinkedInIcon } from '@duck/ui'
import { StandardLoader } from '../StandardLoader'

type IconComponent = ComponentType<{ className?: string }>

const SocialLoadingView = ({ Icon }: { Icon: IconComponent }) => (
    <div className="flex flex-col items-center justify-center flex-1 min-h-[380px]">
        <Icon className="w-12 h-12 mb-4" />
        <StandardLoader size="md" />
    </div>
)

export const LinkedInLoadingView = () => (
    <SocialLoadingView Icon={LinkedInIcon} />
)

export const GoogleLoadingView = () => (
    <SocialLoadingView Icon={GoogleIcon} />
)

